<aside class="card">
    <!-- <img src="/assets/img/bg/project-steam.png" alt="" class="card-img-top" alt="..." /> -->
    <app-carousel [project]="_project" [notCardImage]="false"></app-carousel>
    <!-- <img src="https://nycha-my.sharepoint.com/:i:/r/personal/abigail_fradkin_nycha_nyc_gov/Documents/Capital%20Projects%20%26%20Needs%20Tracker/Reporting%20Tool/Photo%20Folders%20for%20AECOM/NYCHA%20Project%20Photos/e20739_3.jpg" alt="" width="400" height="250" class="card-img-top" alt="..." /> -->
    <button class="btn btn-link" role="button" (click)="triggerClose()">
      <div class="icon icon-close icon-white"></div>
    </button>
  <div class="card-body">
    <h4 class="card-title">
      <span class="development-title skiptranslate"
        >{{ _project.developmentName | titleCasewithAvoidWords }} /</span
      >
      {{ _project.name | titleCasewithAvoidWords | simplifyWords }}
    </h4>
    <div class="mb-2" *ngIf="isMultiProject">
      <div class="row">
        <div style="width: 25px" class="location-image">
          <img
            src="assets/img/icons/multiVector.svg"
            width="20"
            height="22"
            alt="..."
          />
        </div>
        <div class="development-sub-title skiptranslate col-9 multiproject">
            {{ multiMultisiteProjectTitle }}
        </div>
      </div>
    </div>
    <div class="mb-2">
      <h5 class="titleCase">Project Status:</h5>
      <div *ngFor="let status of projectStatus" class="project-category">
        {{ status | titleCasewithAvoidWords }}
      </div>
    </div>
    <div class="mb-2">
      <h5 class="titleCase">Estimated Budget:</h5>
      <div class="budget">{{ budget | currency : "USD" : "$" : "1.0-0" }}</div>
    </div>
    <div class="mb-2">
      <h5 class="titleCase">Funding Source:</h5>
      <div *ngFor="let source of fundingSource" class="project-category">
        {{ source | titleCasewithAvoidWords }}
      </div>
    </div>
  </div>

  <footer class="card-footer d-grid">
    <a [routerLink]="'/projects/' + project.developmentId + '/' + project.id" class="btn btn-primary text-light" role="button">
      More Details
    </a>
  </footer>
</aside>
